/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-misused-promises */
import {useState, useEffect} from 'react';
import xml2js, {Builder} from 'xml2js';
import {toast} from 'react-toastify';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import {useNavigate} from 'react-router-dom';

import LayoutMain from 'components/Layouts/LayoutMain';
import ActivePolicy from './ActivePolicy';
import TestingPolicy from './TestingPolicy';
import RepositoryPolicy from './RepositoryPolicy';
import {
	useDeletePolicyMutation,
	useGetPoliciesCountQuery,
	useUpdatePolicyInactivatedMutation,
	useUpdatePolicyActivateMutation,
	useUpdatePolicyTestMutation,
	useUpdatePolicyUnsetTestMutation,
	useGetAllPoliciesQuery,
	useLazyGetPolicyQuery,
	useGetActivePolicyQuery,
	useGetTestingPolicyQuery,
} from 'services';
import ModalPolicyView from './components/ModalPolicyView';
import type {Policy} from 'types/general';
import MappingsPolicy from './MappingsPolicy';
import {convertViewJson, exportDataToXml} from 'utils';

const TIME_INTERVAL = 59000;

TimeAgo.setDefaultLocale(en.locale);
TimeAgo.addLocale(en);

export const defaultPolicyData = {
	title: '',
	version: 0,
	enabled: false,
	state: 'INACTIVE',
	description: '',
};

export const defaultTestingPolicyData = {
	title: '',
	version: 0,
	enabled: false,
	state: 'INACTIVE',
	description: '',
};

const PolicyIndex = () => {
	const navigate = useNavigate();

	const parser = new xml2js.Parser();
	const builder = new Builder();
	const timeAgo = new TimeAgo('en-US');

	const [page, setPage] = useState<number>(0);
	const [activeXMLJson, setActiveXMLJson] = useState([]);
	const [viewXMLJson, setViewXMLJson] = useState([]);
	const [testingXMLJson, setTestingXMLJson] = useState([]);
	const [initialDate, setInitialDate] = useState<Date>(new Date());
	const [timeStr, setTimeStr] = useState<string>('just now');

	// all policies with count for pagination
	const {
		data: totalPolicies = 0,
		isLoading: isLoadingCount,
		refetch: refetchCountPolicy,
	} = useGetPoliciesCountQuery();

	const {
		data: getAllPolicies = [],
		isLoading,
		refetch: refetchAllPolicies,
	} = useGetAllPoliciesQuery(page);

	const {
		data: getActivePolicy = defaultPolicyData,
		refetch: refetchActivePolicy,
	} = useGetActivePolicyQuery();

	const {
		data: getTestingPolicy = defaultTestingPolicyData,
		refetch: refetchTestingPolicy,
	} = useGetTestingPolicyQuery();

	// remove policy
	const [deletePolicy] = useDeletePolicyMutation();

	// endpoints update radio button
	const [updatePolicyInactivated] = useUpdatePolicyInactivatedMutation();
	const [updatePolicyActivated] = useUpdatePolicyActivateMutation();
	const [updatePolicyTest] = useUpdatePolicyTestMutation();
	const [updatePolicyUnsetTest] = useUpdatePolicyUnsetTestMutation();

	// individual policy
	const [getPolicy] = useLazyGetPolicyQuery();
	const handleGetTextContent = async (
		policy: Policy,
		redirect = false,
		edit = false,
		isTestingPolicy = false,
	) => {
		try {
			const response = await getPolicy(policy).unwrap();

			// parse xml
			parser.parseString(response, (err, result) => {
				if (err) {
					toast.error('XML parse error');
					return;
				}

				if (result) {
					const res = result.policySet?.policy;

					if (typeof result.policySet !== 'string') {
						const policyTmp = res.map((el: any) => {
							let actionsTmp: any[];
							let conditions: any[];

							if (el?.actions?.some((j: any) => Object.keys(j)?.length > 0)) {
								actionsTmp = el?.actions.map((j: any) => convertViewJson(j));
							} else {
								actionsTmp = [{}];
							}

							if (
								el?.conditions?.some((j: any) => Object.keys(j)?.length > 0)
							) {
								conditions = el?.conditions;
							} else {
								conditions = [{}];
							}

							return {...el, conditions, actions: actionsTmp};
						});

						if (isTestingPolicy) {
							setTestingXMLJson(policyTmp);
						} else {
							setActiveXMLJson(policyTmp);
						}

						if (redirect) {
							navigate(`/policy/${edit ? 'edit' : 'view'}`, {
								state: {
									XMLJson: policyTmp,
									activePolicy: policy,
								},
							}) as never;
						}
					}
				}
			});
		} catch (error) {
			console.error(error);
		}
	};
	const handleGetTextContentToView = async (policy: Policy) => {
		try {
			const response = await getPolicy(policy).unwrap();

			// parse xml
			parser.parseString(response, (err, result) => {
				if (err) {
					toast.error('XML parse error');
					return;
				}

				if (result) {
					const res = result.policySet?.policy;

					if (typeof result.policySet !== 'string') {
						const policyTmp = res.map((el: any) => {
							let actionsTmp: any[];
							let conditions: any;

							if (el?.actions?.some((j: any) => Object.keys(j)?.length > 0)) {
								actionsTmp = el?.actions.map((j: any) => convertViewJson(j));
							} else {
								actionsTmp = [{}];
							}

							if (
								el?.conditions?.some((j: any) => Object.keys(j)?.length > 0)
							) {
								conditions = el?.conditions;
							} else {
								conditions = [{}];
							}

							return {...el, conditions, actions: actionsTmp};
						});

						setViewXMLJson(policyTmp);
					}
				}
			});
		} catch (error) {
			console.error(error);
		}
	};

	/**
	 * The function `handleDownloadXML` takes a policy object, retrieves the policy data, parses it as
	 * XML, and exports it as an XML file.
	 * @param {Policy} policy - The `policy` parameter is an object that represents a policy. It is used
	 * as an input to the `getPolicy` function and is also used to set the title of the exported XML file.
	 */
	const handleDownloadXML = async (policy: Policy) => {
		try {
			const response = await getPolicy(policy).unwrap();

			// parse xml
			parser.parseString(response, (err, result) => {
				if (err) {
					toast.error('XML parse error');
					return;
				}
				if (result) {
					const res = result.policySet?.policy;

					if (typeof result.policySet !== 'string') {
						const policyTmp = res.map((el: any) => {
							let actionsTmp: any[];
							let conditions: any;

							if (el?.actions?.some((j: any) => Object.keys(j)?.length > 0)) {
								actionsTmp = el?.actions.map((j: any) => convertViewJson(j));
							} else {
								actionsTmp = [{}];
							}

							if (
								el?.conditions?.some((j: any) => Object.keys(j)?.length > 0)
							) {
								conditions = el?.conditions;
							} else {
								conditions = [{}];
							}

							return {...el, conditions, actions: actionsTmp};
						});

						exportDataToXml(
							builder.buildObject({
								policySet: {policy: policyTmp},
							}),
							policy.title,
						);
					}
				}
			});
		} catch (error) {
			console.error(error);
		}
	};

	/* It's a hook that runs after the component is rendered. */
	useEffect(() => {
		if (getActivePolicy && getActivePolicy.version !== 0) {
			void handleGetTextContent(getActivePolicy, false, false, false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getActivePolicy]);

	/* It's a hook that runs after the component is rendered. */
	useEffect(() => {
		if (getTestingPolicy && getTestingPolicy.version !== 0) {
			void handleGetTextContent(getTestingPolicy, false, false, true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getTestingPolicy]);

	/**
	 * It sets the page to the number passed in.
	 * @param {number} param - number - This is the parameter that is passed to the function. In this
	 * case, it's a number.
	 */
	const handlePage = (param: number) => setPage(param);

	const handleDateAgo = () => {
		setTimeStr(timeAgo.format(initialDate));
	};

	/* A custom hook that is used to update the time every 59 seconds. */
	useEffect(() => {
		const interval = setInterval(() => {
			handleDateAgo();
		}, TIME_INTERVAL);
		return () => clearInterval(interval);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	/* It's a hook that runs after the component is rendered. */
	useEffect(() => {
		setInitialDate(new Date());
		handleDateAgo();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getAllPolicies]);

	const handleRefetchData = () => {
		void refetchAllPolicies();
		void refetchActivePolicy();
		void refetchTestingPolicy();
		void refetchCountPolicy();
	};

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => handleRefetchData(), []);

	return (
		<LayoutMain isLoading={isLoading || isLoadingCount}>
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-12">
						<h1 className="mt-2">Policy Sets Management</h1>
					</div>
				</div>

				<div className="row mt-4">
					<div className="col-xs-12 col-md-4">
						<ActivePolicy
							activePolicy={getActivePolicy}
							XMLJson={activeXMLJson}
							timeStr={timeStr}
							handleGetTextContent={handleGetTextContent}
							onDownloadXML={handleDownloadXML}
						/>
					</div>

					<div className="col-xs-12 col-md-8">
						<RepositoryPolicy
							getAllPolicies={getAllPolicies}
							totalPolicies={totalPolicies}
							deletePolicy={deletePolicy}
							updatePolicyInactivated={updatePolicyInactivated}
							updatePolicyActivated={updatePolicyActivated}
							updatePolicyTest={updatePolicyTest}
							updatePolicyUnsetTest={updatePolicyUnsetTest}
							onPage={handlePage}
							timeStr={timeStr}
							refetch={handleRefetchData}
							handleGetTextContent={handleGetTextContent}
							handleGetTextContentToView={handleGetTextContentToView}
							onDownloadXML={handleDownloadXML}
						/>
					</div>
				</div>

				<div className="row mt-4 px-1">
					<div className="col-xs-12 col-md-4">
						<TestingPolicy
							testingPolicy={getTestingPolicy}
							XMLJson={testingXMLJson}
							timeStr={timeStr}
							handleGetTextContent={handleGetTextContent}
							onDownloadXML={handleDownloadXML}
						/>
					</div>

					<div className="col-xs-12 col-md-8">
						<MappingsPolicy />
					</div>
				</div>

				{/* view full XML by policy */}
				<ModalPolicyView
					type="Policy"
					id="modalActivePolicyView"
					XMLParse={builder.buildObject({policySet: {policy: activeXMLJson}})}
				/>

				<ModalPolicyView
					type="Policy"
					id="modalTestingPolicyView"
					XMLParse={builder.buildObject({policySet: {policy: testingXMLJson}})}
				/>

				<ModalPolicyView
					type="Policy"
					id="modalSelectedPolicyView"
					XMLParse={builder.buildObject({policySet: {policy: viewXMLJson}})}
				/>
			</div>
		</LayoutMain>
	);
};

export default PolicyIndex;
